import { render, staticRenderFns } from "./AndroidTop.vue?vue&type=template&id=618c2770&scoped=true&"
import script from "./AndroidTop.vue?vue&type=script&lang=js&"
export * from "./AndroidTop.vue?vue&type=script&lang=js&"
import style0 from "./AndroidTop.vue?vue&type=style&index=0&id=618c2770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c2770",
  null
  
)

component.options.__file = "AndroidTop.vue"
export default component.exports